import type { SVGProps } from 'react'

/** FIT Editor mark: the letter F drawn as one route with a start and a finish point. Uses currentColor. */
export function AppLogo(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 24 24" fill="none" {...props}>
      <path
        d="M7 20 V5.5 H17.5 M7 12.5 H14"
        stroke="currentColor"
        strokeWidth={2.6}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="7" cy="20" r="2.2" fill="currentColor" />
      <circle cx="17.5" cy="5.5" r="2.2" fill="currentColor" />
    </svg>
  )
}
